import * as tslib_1 from "tslib";
import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';
/**
 * Tag name marking an FBO that offers self-serve fuel.
 */
export var FBO_SELF_SERVE_FUEL_TAG = 'Fuel::Self Serve';
/**
 * An FBO ("Business Finder") search result returned by the AirportsAPI `~/fbos` endpoint. An FBO is a
 * business carrying the `Admin::BusinessIsFbo` tag, mirroring the iOS app's FBO classification. Mirrors
 * {@link FlyingClubResult}'s `static parse` convention.
 */
var FboResult = /** @class */ (function (_super) {
    tslib_1.__extends(FboResult, _super);
    function FboResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FboResult.parse = function (data) {
        var tags = (data.tags || []).map(function (d) { return d; });
        return Object.assign(new FboResult(), {
            businessId: data.businessId,
            name: data.name || null,
            city: data.city || null,
            stateProvince: data.stateProvince || null,
            latitude: isNumeric(data.latitude) ? +data.latitude : null,
            longitude: isNumeric(data.longitude) ? +data.longitude : null,
            location: (isNumeric(data.latitude) && isNumeric(data.longitude))
                ? parseLatLon(data.latitude, data.longitude) : null,
            phone1: data.phone1 || null,
            webAddress: data.webAddress || null,
            emailAddress: data.emailAddress || null,
            description: data.description || null,
            distance: isNumeric(data.distance) ? +data.distance : null,
            airportIdent: data.airportIdent || null,
            airportName: data.airportName || null,
            tags: tags,
            fuelTypes: (data.fuelTypes || []).map(function (d) { return d; }),
            selfServeFuel: tags.indexOf(FBO_SELF_SERVE_FUEL_TAG) !== -1,
            thumbnailPhotoPath: data.thumbnailPhotoPath || null
        });
    };
    return FboResult;
}(BusinessFinderResult));
export { FboResult };
